module.exports = __webpack_public_path__ + "static/media/ellipse.e6b59cda.svg";